module.exports = __webpack_public_path__ + "img/popular.75c30a27.png";